<template>
  <div class="chart-container">
    <div v-if="size !== 'mini'" class="chart-legend-container" style="height: 50px;">
      <label style="margin-left: 10px;">
        <span class="chart-mark" :style="{ backgroundColor: colorSet.blue.pointBackgroundColor }"></span><span class="chart-legend-name">完璧な予測</span>
      </label>
      <label style="margin-left: 10px;">
        <span class="chart-mark" :style="{ backgroundColor: colorSet.red.pointBackgroundColor }"></span><span class="chart-legend-name">このモデルの予測</span>
      </label>
      <label style="margin-left: 10px;">
        <span class="chart-mark" :style="{ backgroundColor: colorSet.green.pointBackgroundColor }"></span><span class="chart-legend-name">ランダムな予測</span>
      </label>
    </div>
    <div class="chart-main-container">
      <chart ref="chart" chartType="line" chartId="CapChart" :width="size === 'mini' ? 300 : 836"
             :height="size === 'mini' ? 180 : 400"></chart>
    </div>
    <div class="chart-column-container" v-if="capComparison.results.length > 1 && size !== 'mini'">
      <el-radio v-for="(result, index) in capComparison.results" v-model="selectedColumnIndex" name="cap-column"
                :label="index">{{ result.name }}
      </el-radio>
    </div>
  </div>
</template>

<script lang="js">
import ChartCmp from './base.vue'
import { Category } from '../../defines/const'
import { GraphLineColorSet } from '../../defines/chart-color'
import CommonUtil from '../../utils/common'
import FormatUtil from '../../utils/format'

export default {
  name: 'CapChartCmp',
  components: {
    'chart': ChartCmp
  },
  props: {
    capComparison: {type: Object, default: () => {}},
    yName: '',
    categoryId: '',
    size: '',
    initialColumnIndex: {type: Number, default: 0}
  },
  data () {
    return {
      selectedColumnIndex: -1,
      selectedCapResult: null,
      colorSet: GraphLineColorSet
    }
  },
  created () {
    this.selectedColumnIndex = this.initialColumnIndex
    this.$nextTick(() => {
      this.$forceUpdate()
    })
  },
  watch: {
    selectedColumnIndex (newIndex) {
      if (newIndex < 0) return
      this.selectedCapResult = this.capComparison.results[newIndex]
    },
    selectedCapResult (capResult) {
      if (!capResult) return

      const yLabel = (this.categoryId === Category.CLF
        ? `「${this.yName} = ${this.selectedCapResult.name}」の累積発生率`
        : `「${this.yName}」の累積発生率`)
      const perfect = capResult.value.map(value => value.perfect)
      const model = capResult.value.map(value => value.model)
      const random = capResult.value.map(value => value.random)
      const isMini = (this.size === 'mini')

      let labels = []
      for (let i = 0; i < 101; i++) {
        if (i % 20 === 0) {
          labels.push(i.toString())
        } else {
          labels.push('')
        }
      }

      let datasets = []
      datasets.push(
        Object.assign(
          {
            label: '完璧な予測',
            fill: false,
            data: perfect,
            pointRadius: 0
          },
          this.colorSet.blue
        )
      )
      datasets.push(
        Object.assign(
          {
            label: 'このモデルの予測',
            fill: false,
            data: model,
            pointRadius: 0
          },
          this.colorSet.red
        )
      )
      datasets.push(
        Object.assign(
          {
            label: 'ランダムな予測',
            fill: false,
            data: random,
            pointRadius: 0
          },
          this.colorSet.green
        )
      )

      const chartData = {
        labels: labels,
        datasets: datasets
      }
      const options = {
        responsive: false,
        title: {
          display: false
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              id: 'y',
              position: 'left',
              scaleLabel: {
                display: !isMini,
                labelString: yLabel,
                fontSize: 16
              },
              ticks: {
                max: 1,
                min: 0,
                callback: function (value, index, values) {
                  return CommonUtil.isEmpty(value) ? '' : `${FormatUtil.percentage(value)}%`
                }
              }
            }
          ],
          xAxes: [
            {
              display: !isMini,
              scaleLabel: {
                display: true,
                labelString: '高 ← スコア順 → 低',
                fontSize: 16
              },
              ticks: {
                max: 1,
                min: 0,
                showLine: false,
                maxRotation: 0,
                callback: function (value, index, values) {
                  return CommonUtil.isEmpty(value) ? '' : `${value}%`
                }
              }
            }
          ]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              const datasetIndex = tooltipItem.datasetIndex
              let label = data.datasets[datasetIndex].label || ''

              if (CommonUtil.isNotEmpty(label)) {
                label += ': '
              }
              label += FormatUtil.percentage(tooltipItem.yLabel) + '%'

              return label
            }
          }
        }
      }

      this.$refs.chart.renderChart(chartData, options)
    }
  }
}

</script>

<style scoped>
  .chart-container {
    display: flex;
    flex-direction: column;
  }

  .chart-legend-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .chart-legend-container > label {
    display: flex;
    align-items: center;
  }

  .chart-mark {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .chart-legend-name {
    margin-right: 10px;
  }

  .chart-main-container {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/chart/cap.vue